import { useEffect, useState } from "react";

export default function useKeyboardStatus() {
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

    useEffect(() => {
        const threshold = 150; // px shrink we consider "keyboard opened"

        const handleResize = () => {
            if (window.visualViewport) {
                const diff = window.innerHeight - window.visualViewport.height;
                setIsKeyboardOpen(diff > threshold);
            }
        };

        window.visualViewport?.addEventListener("resize", handleResize);
        handleResize(); // run once on mount

        return () => {
            window.visualViewport?.removeEventListener("resize", handleResize);
        };
    }, []);

    return isKeyboardOpen;
}
